import { createSelector } from 'reselect'

// eslint-disable-next-line import/no-cycle
import { isEmpty } from 'helpers/utils'

const getProvincesState = state => state.provinces

export const getProvincesData = createSelector([getProvincesState], provinces =>
  provinces ? provinces.data : null
)

export const getProvinces = createSelector([getProvincesState], provincesState => {
  const provinces = provincesState?.provincesCollection
  return isEmpty(provinces) ? [] : Object.values(provinces)
})

export const getCountriesSearched = createSelector([getProvincesState], provincesState =>
  provincesState?.countriesSearched ? Object.values(provincesState.countriesSearched) : []
)

export const getIsFetchingProvinces = createSelector([getProvincesState], provinces =>
  provinces ? provinces.isFetching : false
)
